<template>
  <div class="newRelease">
    <Card>
      <Card dis-hover :bordered="false" style="text-align: right">
        <Button type="primary" @click="createNews">发布</Button>
      </Card>
      <Table
        :loading="dataLoading"
        :columns="columns"
        :data="data"
        :border="false"
        :stripe="false"
        :highlight-current-row="true"
      >
        <template #action="{ row, index }">
          <el-button  size="small" type="text" @click="editNews(row)">编辑</el-button>
          <el-button :disabled="row.status === '1'" size="small" type="text" @click="releaseNews(row, 1)">发布
          </el-button>
          <el-button size="small" type="text" @click="gotoDetail(row)">查看</el-button>
          <el-button :disabled="row.createUser !== curUser" size="small" type="text" @click="deleteNews(row)">删除
          </el-button>
        </template>
      </Table>
      <Page style="text-align: right;margin-top: 10px"
            show-sizer
            show-total
            transfer
            :total="dataTotal"
            :page-size="pageSize"
            :page-size-opts="pageSizeOpts"
            :current-page="currentPage"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
      ></Page>
    </Card>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "newsRelease",
  data() {
    return {
      dataLoading: false,
      dataTotal: 0,
      columns: [
        {
          title: '发布标题',
          align: 'center',
          key: 'title'
        },
        // {
        //   title: '发布时间',
        //   align: 'center',
        //   // width: '120',
        //   render: (h, params) => {
        //     return h('div', moment(params.row.releaseTime).format('YYYY-MM-DD HH:mm:ss'))
        //   }
        // },
        {
          title: '开始时间',
          align: 'center',
          render: (h, params) => {
            return h('div', moment(params.row.startTime).format('YYYY-MM-DD'))
          }
        },
        {
          title: '结束时间',
          align: 'center',
          render: (h, params) => {
            return h('div', moment(params.row.endTime).format('YYYY-MM-DD'))
          }
        },

        {
          title: '状态',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.status === '0' ? '草稿' : '已发布')
          }
        },
        {
          width: '200',
          title: '操作',
          // fixed: 'right',
          align: 'center',
          slot: 'action',
        }
      ],
      data: [],
      pageSize: 10,
      pageSizeOpts: [ 10, 20, 30, 40 ],
      currentPage: 1,
      curUser: '',
    }
  },
  watch: {
    userInfo: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          console.log(newVal)
          this.curUser = newVal.userId
        }
      }
    }
  },
  computed: {
    userInfo: {
      get: function () {
        return this.$store.state.user.userInfo
      },
      set: function () {
      }
    }
  },
  mounted() {
    this.getNewsReleasesList()
  },
  methods: {
    gotoDetail(row) {
      this.$router.push({
        name: 'newsDetail',
        query: {
          id: row.id
        }
      })
    },
    createNews() {
      this.$router.push({
        name: 'newsInfo'
      })
    },
    editNews(row) {
      this.$router.push({
        name: 'newsInfo',
        params: {
          row: row
        }
      })
    },
    getNewsReleasesList() {
      this.dataLoading = true
      let params = {
        // status: '0',
        page: this.currentPage,
        size: this.pageSize
      }
      this.$http.post('/api/getNewsReleasesListByToken', params).then(res => {
        console.log(res)
        this.data = res.data.data
        this.dataTotal = res.data.recordsTotal
        this.dataLoading = false
      })
    },
    releaseNews(row, status) {
      let params = { ...row }
      params.status = status
      this.$http.put('/api/newsReleases', params).then(res => {
        if (res.status === 200 || res.status === 201) {
          this.$Message.success('发布成功！')
          this.getNewsReleasesList()
        } else {
          this.$Message.error(res.data.message)
        }
      })
    },
    deleteNews(row) {
      this.$http.delete(`/api/newsReleases/${ row.id }`).then(res => {
        this.getNewsReleasesList()
      })
    },
    pageChange(page) {
      this.currentPage = page
      this.getNewsReleasesList()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getNewsReleasesList()
    },
  }
}
</script>

<style scoped lang="less">
.newRelease {

}
</style>
